"use client";

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const getSubdomain = (): string | null => {
  const hostname = window.location.hostname;
  const mainDomain = "icont.ai";

  if (hostname.includes("localhost")) {
    return "localhost";
  }

  if (hostname.endsWith(mainDomain)) {
    const parts = hostname.split(".");
    const mainParts = mainDomain.split(".");
    const subdomainParts = parts.slice(0, parts.length - mainParts.length);
    return subdomainParts.join(".") || null;
  }

  return null;
};

//const subdomain = getSubdomain();
const subdomain = "comptest1"
const baseUrl =
  subdomain
      ? `https://${subdomain}.icont.ai/api/`
      : `https://console.icont.ai/api/`; // fallback

console.log("base url = ", baseUrl);

export const baseApi = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers) => {
      if (subdomain) {
        headers.set("X-Subdomain", subdomain);
      }
      return headers;
    },
    credentials: "include",
  }),
  tagTypes: [
    "Ticket",
    "Category",
    "Subcategory",
    "Status",
    "TicketHistory",
    "Note",
    "TicketType",
    "Feedback",
    "Priority",
    "Company",
    "Group",
    "Agent",
    "Client",
    "UpdateReason",
    "Chat"
  ],
  endpoints: (builder) => ({}),
});
